import styled from 'styled-components';
import { FlexView, Row, Text } from '@cuemath/comps';

export const Root = styled(FlexView)`
  && {
    display: flex;
    flex-direction: column;
    height: 100vh;
    font-family: 'Open Sans', sans-serif;
  }
`;

export const Header = styled(Row)`
  && {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px;
    border-bottom: 1px solid #eee;
  }
`;

export const Title = styled(Text)`
  && {
    font-size: 20px;
    font-weight: 600;
    color: #2b2b2b;
    margin: 0;
  }
`;

export const SelectorContainer = styled(Row)`
  && {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export const SelectorLabel = styled.span`
  font-size: 13px;
  color: #808080;
`;

export const Select = styled.select`
  padding: 6px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  background: #fff;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: #0177ff;
  }
`;

export const TabBar = styled(Row)`
  && {
    display: flex;
    gap: 0;
    border-bottom: 1px solid #eee;
    padding: 0 24px;
  }
`;

export const Tab = styled.button`
  padding: 10px 20px;
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? '600' : '400')};
  color: ${({ $active }) => ($active ? '#0177ff' : '#808080')};
  background: transparent;
  border: none;
  border-bottom: 2px solid ${({ $active }) => ($active ? '#0177ff' : 'transparent')};
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    color: #0177ff;
  }
`;

export const Content = styled.div`
  flex: 1;
  overflow: hidden;
`;
